import {action, computed, makeObservable, observable} from 'mobx';

export type SelectControllerOption<ValueType> = {
  label: string;
  value: ValueType;
};

export class SelectController<ValueType> {
  options: SelectControllerOption<ValueType>[];
  selected: SelectControllerOption<ValueType>;

  constructor(
    options?: SelectControllerOption<ValueType>[],
    selected?: SelectControllerOption<ValueType>,
  ) {
    this.options = options ?? [];

    if (this.options.length > 0) {
      this.selected = this.options[0]!;
    }

    if (selected) {
      this.selected = selected;
    }

    makeObservable(this, {
      options: observable,
      selected: observable,
      setSelected: action.bound,
      value: computed,
    });
  }

  get value() {
    return this.selected.value;
  }

  getOptionByValue(value: ValueType) {
    return this.options.filter(option => option.value === value)[0]!;
  }

  setOptions(options: SelectControllerOption<ValueType>[]) {
    this.options = options;
  }

  setSelected(option: SelectControllerOption<ValueType>) {
    if (
      this.options
        .map(availableOption => availableOption.value)
        .includes(option.value)
    ) {
      this.selected = option;
    }
  }
}
